/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
export function PipelineIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6V12.3538C12 12.7107 11.6866 13 11.3 13H5.7C5.3134 13 5 12.7107 5 12.3538V6.64615C5 6.28926 5.3134 6 5.7 6H12Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 6H12V14.2727V19.2364C12 19.6581 12.3134 20 12.7 20H18.3C18.6866 20 19 19.6581 19 19.2364V11.7273V6Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
